import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl-next';
import SectionMessage from '@atlaskit/section-message';
import { Text } from '@atlaskit/primitives';

const messages = defineMessages({
	title: {
		id: 'forge.ui.extension.not.installed.title',
		defaultMessage: 'App not available',
		description: 'Title shown when a Forge extension/macro is not installed on the tenant',
	},
	message: {
		id: 'forge.ui.extension.not.installed.message',
		defaultMessage:
			"We can't display this content because the app isn't installed. Contact your administrator to install it.",
		description: 'Message shown when a Forge extension/macro is not installed on the tenant',
	},
});

export const ExtensionNotInstalled = (): React.JSX.Element => {
	const intl = useIntl();

	return (
		<SectionMessage
			title={intl.formatMessage(messages.title)}
			appearance="warning"
			testId="extension-not-installed"
		>
			<Text as="p">
				<FormattedMessage {...messages.message} />
			</Text>
		</SectionMessage>
	);
};
